import { gql } from "@apollo/client";

export const AuthRefreshToken = gql`
  mutation AuthRefreshToken($refreshToken: String!, $region: AWSRegions!) {
    authRefreshToken(refreshToken: $refreshToken, region: $region) {
      idToken
      accessToken
      refreshToken
    }
  }
`;
